import styles from "./Modal.module.css";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Button from "../../../components/components-ui/Button/Button";
import { Col, Grid } from "../../../components/Grid";
import Api from "../../../services/Api";
import { toast } from "react-toastify";

const API_ATUALIZAR_SENHA = "/usuario/updatepassword";

function ModalAtualizarSenha({ setOpenModal }) {
  async function updatePassword(values) {
    const senhaAtual = values.senhaAtual;
    const senhaNova = values.confirmarSenha;

    await Api.post(API_ATUALIZAR_SENHA, { senhaAtual, senhaNova })
      .then((res) => {
        if (res.data.error === 0) {
          toast.success(res.data.msg);
          setOpenModal(false);
          return;
        }
        toast.error(res.data.msg);
      })
      .catch((error) => {
        toast.error(error.response.data.msg);
      });
  }

  const validationSchema = Yup.object().shape({
    senhaAtual: Yup.string().nullable().required("Campo Obrigatório"),
    senhaNova: Yup.string().nullable().required("Campo Obrigatório"),
    confirmarSenha: Yup.string()
      .oneOf([Yup.ref("senhaNova"), null], "As senhas não conferem")
      .required("Campo obrigatório"),
  });

  return (
    <div className={styles.modal_container}>
      <h2 style={{ textAlign: "center" }}>Atualizar Senha</h2>
      <Formik
        initialValues={{ senhaAtual: "", senhaNova: "", confirmarSenha: "" }}
        validationSchema={validationSchema}
        onSubmit={(values) => updatePassword(values)}
      >
        {({
          errors,
          touched,
          isSubmitting,
        }) => (
          <Form>
            <div>
              <Grid justifyContent={"center"}>
                <Col size={7}>
                  <label>Senha Atual</label>
                  <Field type="password" name="senhaAtual" />
                  {errors.senhaAtual && touched.senhaAtual ? (
                    <span className={styles.alertError}>
                      {errors.senhaAtual}
                    </span>
                  ) : null}
                </Col>
              </Grid>
              <Grid justifyContent={"center"}>
                <Col size={7}>
                  <label>Nova Senha</label>
                  <Field type="password" name="senhaNova" />
                  {errors.senhaNova && touched.senhaNova ? (
                    <span className={styles.alertError}>
                      {errors.senhaNova}
                    </span>
                  ) : null}
                </Col>
              </Grid>
              <Grid justifyContent={"center"}>
                <Col size={7}>
                  <label>Confirmar Senha</label>
                  <Field type="password" name="confirmarSenha" />
                  {errors.confirmarSenha && touched.confirmarSenha ? (
                    <span className={styles.alertError}>
                      {errors.confirmarSenha}
                    </span>
                  ) : null}
                </Col>
              </Grid>
              <div className={styles.buttons_container}>
                <Button
                  title="Salvar"
                  type="submit"
                  disabled={isSubmitting}
                  className={styles.button_sm}
                />
                <Button
                  color="secondary"
                  title="Voltar"
                  type="button"
                  onClick={() => setOpenModal(false)}
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default ModalAtualizarSenha;
